import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import cx from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons/faList'
import { faDrawCircle } from '@fortawesome/pro-duotone-svg-icons/faDrawCircle'
import Grid from '@softwaredev_cegeka/stix-core/dist/components/Grid'
import Button from '@softwaredev_cegeka/stix-core/dist/components/Button'
import IconWrapper from '@softwaredev_cegeka/stix-core/dist/components/IconWrapper'

import { reverse } from 'src/routes/config'
// Styles
import styles from './contentHeader.module.scss'

class ContentHeader extends Component {
    render() {
        const { title, isActive } = this.props
        return (
            <Grid.Container fluid>
                <div className={styles.contentHeaderWrapper}>
                    <div className={styles.contentHeaderActions}>
                        <h1 className={styles.contentTitle}>{title}</h1>
                        <div
                            id={'refresh-portal'}
                            className={styles.actionBtnGroup}
                        />
                        <div className={styles.viewSwitch}>
                            <Button
                                data-testid={'node-view-btn'}
                                as={NavLink}
                                className={cx({ active: isActive })}
                                to={reverse('solutions', { view: 'graph' })}
                            >
                                <IconWrapper size="1.4rem" iconSize="1.3rem">
                                    <FontAwesomeIcon
                                        icon={faDrawCircle}
                                        title={'Node view'}
                                        srOnly
                                    />
                                </IconWrapper>
                            </Button>
                            <Button
                                data-testid={'solutions-view-btn'}
                                as={NavLink}
                                className={cx({ active: isActive })}
                                to={reverse('solutions', { view: 'list' })}
                            >
                                <IconWrapper size="1.4rem" iconSize="1.3rem">
                                    <FontAwesomeIcon
                                        icon={faList}
                                        title={'List view'}
                                        srOnly
                                    />
                                </IconWrapper>
                            </Button>
                        </div>
                    </div>
                    <div id={'actions-portal'} className={styles.actionPortal}>
                        <div
                            id={'actions-portal-right'}
                            className={styles.right}
                        />
                    </div>
                </div>
            </Grid.Container>
        )
    }
}

export default ContentHeader
